import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { AUTO_DETECT_CONSTANTS, MODAL_MSG_CONSTANTS } from '../Constants/AutoDetectionConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ImageComponent from 'atoms/Image';
import { ChannelManager } from 'common/manager';
import { LOCAL_STORAGE_KEYS, DISPOSITIONNEW, DISPOSITIONOLD } from 'common/constants/SharedConstants';
import { isValidValue } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const { Location_Error, errorIcon } = IMAGE_PATH;

const {
  TAKEAWAY_TITLE,
  TAKEAWAY_CONTENT,
  TAKEAWAY_TOAST_MSG,
  DINEIN_TITLE,
  DINEIN_CONTENT,
  DINEIN_TOAST_MSG,
  NOSTORE_TITLE,
  NOSTORE_CONTENT,
  NOSTORE_TOAST_MSG,
  CLOSED_STORE_TITLE,
  CLOSED_STORE_CONTENT,
  LOCATION_ALERT_MSG,
  CLOSED_STORE_TOAST_MSG,
} = MODAL_MSG_CONSTANTS;
const { DINE_IN, DISTANCE_20000MR, START_ORDER_BUTTON, BROWSE_MENU_BUTTON } = AUTO_DETECT_CONSTANTS;

const {
  SEARCH_ORDER_DATA = '',
  SELECTED_TILE_DATA = '',
  SCHEDULE_ORDER_TIME_DATA = '',
  SET_DISPOSITION,
  USER_LOCALIZED,
  CURRENT_STORE_INFO,
  SCHEDULE_ORDER_TIME_PRESERVE_TIME,
  SET_FORCERELOAD,
} = START_ORDER_CONSTANTS;

export const checkStoresWithDistance = (
  storesWithLinearDistance,
  dispositionType,
  maxDistance,
  checkStoresForNextDisposition,
  callStatusAPI,
  googleDistanceAPI,
) => {
  if (storesWithLinearDistance?.length) {
    dispositionType.toUpperCase() === 'DELIVERY'
      ? googleDistanceAPI(storesWithLinearDistance)
      : callStatusAPI(storesWithLinearDistance, dispositionType);
  } else if (!storesWithLinearDistance?.length) {
    checkStoresForNextDisposition(dispositionType, maxDistance);
  }
};

export const filterStatusCallResponse = (
  storeList,
  getLocalized,
  setAutoDetectFlow,
  setClosedStore,
  activeDistance,
  activeDisposition,
  userLocationAccessStatus,
  localized,
  setLocalizationChange,
  checkStoresForNextDisposition,
  setEligibleStore,
  setIsCurrentlyClosed,
) => {
  const finalStores = storeList.filter(store => {
    return (
      store?.id &&
      store?.location?.latitude &&
      store?.location?.longitude &&
      store?.summary?.status?.currentStatus &&
      store?.summary?.status?.currentStatus === 'OPEN' &&
      store?.summary?.menu?.catalogs?.length &&
      store?.summary?.timings?.operatingHours?.length > 0 &&
      store?.summary?.timings?.asap
    );
  });
  if (finalStores?.length > 0) {
    if (localized) {
      var dispositionNew = JSON.parse(localStorage.getItem(DISPOSITIONNEW));
      if (dispositionNew) {
        if (finalStores[0].id !== dispositionNew.store.id || finalStores[0].service !== dispositionNew.type) {
          setLocalizationChange(true);
          setAutoDetectFlow(false);
          setEligibleStore(finalStores[0]);
        } else {
          setAutoDetectFlow(false);
        }
      }
    } else {
      getLocalized(finalStores[0]);
    }
  } else {
    setIsCurrentlyClosed(true);
    checkStoresForNextDisposition(activeDisposition, activeDistance);
  }
};

export const setNewDisposition = (
  dispositionNew,
  userOrderStateDispatch,
  userOrderState,
  activeDisposition,
  finalStore,
  dateTimeObj,
) => {
  userOrderStateDispatch({
    type: SET_DISPOSITION,
    value: {
      oldvalue: dispositionNew,
      newValue: {
        type: activeDisposition,
        store: finalStore,
        date: dateTimeObj.date,
        time: dateTimeObj.time,
        interval: dateTimeObj.interval,
        selectedTime: dateTimeObj.selectedTime,
        deliveryAddress: userOrderState?.scheduleOrderData?.deliveryAddress,
      },
    },
  });
  localStorage.setItem(DISPOSITIONOLD, JSON.stringify(dispositionNew));
  localStorage.setItem(
    DISPOSITIONNEW,
    JSON.stringify({
      type: activeDisposition,
      store: finalStore,
      date: dateTimeObj.date,
      time: dateTimeObj.time,
      selectedTime: dateTimeObj.selectedTime,
      interval: dateTimeObj.interval,
      deliveryAddress: userOrderState?.scheduleOrderData?.deliveryAddress,
    }),
  );

  userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
  userOrderStateDispatch({
    type: USER_LOCALIZED,
    value: { isLocalized: true },
  });
};

export const clearDisposition = (userOrderStateDispatch, setUserParams, dispatch, userParams) => {
  const { SCHEDULE_ORDER_DATA, DISPOSITION_METHOD } = START_ORDER_CONSTANTS;

  const {
    DISPOSITION_TYPE,
    DISPOSITION_NEW,
    CURRENT_STORE_INFO_STORAGE,
    STORE_INFO,
    DISPOSITION_OLD,
    DATE_TIME_ORDER,
    SAVED_TIME_ORDER,
  } = LOCAL_STORAGE_KEYS;

  let dispositionDefaultData = {
    type: '',
    store: '',
    date: '',
    time: '',
    interval: '',
    deliveryAddress: '',
    deliveryAddressLine: '',
    selectedTime: '',
  };
  userOrderStateDispatch({
    type: SET_DISPOSITION,
    value: {
      oldvalue: dispositionDefaultData,
      newValue: dispositionDefaultData,
    },
  });
  localStorage.removeItem(DISPOSITION_OLD);
  localStorage.removeItem(DISPOSITION_NEW);
  userOrderStateDispatch({
    type: SCHEDULE_ORDER_TIME_DATA,
    value: { selectedDateTime: {} },
  });
  userOrderStateDispatch({
    type: SCHEDULE_ORDER_TIME_PRESERVE_TIME,
    value: {},
  });
  localStorage.removeItem(DATE_TIME_ORDER);
  localStorage.removeItem(SAVED_TIME_ORDER);
  dispatch(
    setUserParams({
      ...userParams,
      localized: false,
    }),
  );
  userOrderStateDispatch({
    type: USER_LOCALIZED,
    value: { isLocalized: false },
  });
  userOrderStateDispatch({
    type: SCHEDULE_ORDER_DATA,
    value: {
      showScheduleOrderCatering: false,
      selectedStoreInfo: {},
      changeFlow: '',
      isAddressFlow: false,
      deliveryAddress: {},
      deliveryAddressLine: '',
    },
  });
  userOrderStateDispatch({
    type: DISPOSITION_METHOD,
    value: { dispositionType: '' },
  });
  localStorage.removeItem(DISPOSITION_TYPE);
  localStorage.removeItem(STORE_INFO);
  localStorage.removeItem(CURRENT_STORE_INFO_STORAGE);
  userOrderStateDispatch({
    type: CURRENT_STORE_INFO,
    value: {},
  });
};

export const updateCurrentStoreInfo = (
  userOrderStateDispatch,
  activeDisposition,
  dateTimeObj,
  store,
  tenantReducer,
) => {
  userOrderStateDispatch({ type: SELECTED_TILE_DATA, value: { selectedData: {} } });
  // update currently selected store info
  localStorage.setItem('currentStoreInfo', JSON.stringify(store));
  userOrderStateDispatch({
    type: CURRENT_STORE_INFO,
    value: store,
  });

  userOrderStateDispatch({
    type: SCHEDULE_ORDER_TIME_DATA,
    value: { selectedDateTime: dateTimeObj },
  });
  userOrderStateDispatch({
    type: SCHEDULE_ORDER_TIME_PRESERVE_TIME,
    value: { selectContentTime: 'ASAP' },
  });
  userOrderStateDispatch({
    type: SET_FORCERELOAD,
    value: { forceReload: true },
  });
  localStorage.setItem('tenantReducer', JSON.stringify(tenantReducer));
  localStorage.setItem('selectedTile', JSON.stringify({}));
  localStorage.setItem('dispositionType', activeDisposition);
  localStorage.setItem('storeInfo', JSON.stringify(store));
  localStorage.setItem('dateTimeOrder', JSON.stringify(dateTimeObj));
  localStorage.setItem('savedTimeOrder', 'ASAP');
};
export const getTitleMsg = (isPickupOrDineIn, closedStore, noStore, activeDisposition) => {
  let displayMsg = '';
  if (isPickupOrDineIn) {
    displayMsg =
      activeDisposition === DINE_IN ? translateWithI18Next(DINEIN_TITLE) : translateWithI18Next(TAKEAWAY_TITLE);
  } else if (noStore) {
    displayMsg = translateWithI18Next(NOSTORE_TITLE);
  } else if (closedStore) {
    displayMsg = translateWithI18Next(CLOSED_STORE_TITLE);
  }
  return displayMsg;
};
export const getContentMsg = (isPickupOrDineIn, closedStore, noStore, activeDisposition) => {
  let displayMsg = '';
  if (isPickupOrDineIn) {
    displayMsg =
      activeDisposition === DINE_IN ? translateWithI18Next(DINEIN_CONTENT) : translateWithI18Next(TAKEAWAY_CONTENT);
  } else if (noStore) {
    displayMsg = translateWithI18Next(NOSTORE_CONTENT);
  } else if (closedStore) {
    displayMsg = translateWithI18Next(CLOSED_STORE_CONTENT);
  }
  return displayMsg;
};

export const getToastMessage = (
  isPickupOrDineIn,
  closedStore,
  noStore,
  activeDisposition,
  storeTiming,
  setIsPickupOrDineIn,
  setNoStore,
  setClosedStore,
) => {
  let displayMsg = '';

  if (isPickupOrDineIn) {
    setIsPickupOrDineIn(false);
    displayMsg =
      activeDisposition === DINE_IN ? translateWithI18Next(DINEIN_TOAST_MSG) : translateWithI18Next(TAKEAWAY_TOAST_MSG);
  } else if (noStore) {
    setNoStore(false);
    displayMsg = translateWithI18Next(NOSTORE_TOAST_MSG);
  } else if (closedStore) {
    setClosedStore(false);
    displayMsg = `${translateWithI18Next(CLOSED_STORE_TOAST_MSG)} ${convert24To12HourFormat(
      storeTiming?.from,
    )} to ${convert24To12HourFormat(storeTiming?.to)}`;
  }
  return displayMsg;
};

export const convert24To12HourFormat = time => {
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) {
    time = time.slice(1);
    time[5] = +time[0] < 12 ? 'AM' : 'PM';
    time[0] = +time[0] % 12 || 12;
  }
  return time.join('');
};

export function displayMsgAfterPickUpAndDineIn(
  gotoMenuPage,
  gotToHome,
  isPickupOrDineIn,
  closedStore,
  noStore,
  activeDisposition,
  dispositionNew,
  userOrderStateDispatch,
  setUserParams,
  dispatch,
  userParams,
) {
  const PRODUCT_NOT_FOUND_CONSTANTS = {
    HEADER_MSG: {
      MSGTXT1: getTitleMsg(isPickupOrDineIn, closedStore, noStore, activeDisposition),
    },
    CONTENT_MSG: getContentMsg(isPickupOrDineIn, closedStore, noStore, activeDisposition),
  };

  return (
    (isPickupOrDineIn || closedStore || noStore) && (
      <CartAlertFormInsideModel
        handleClose={gotToHome}
        classNames='clear-cart-modal'
        CartAlertForm={
          <CartAlertForm
            splitTitle={PRODUCT_NOT_FOUND_CONSTANTS.HEADER_MSG}
            contentMsg={PRODUCT_NOT_FOUND_CONSTANTS.CONTENT_MSG}
            imageSrc={Location_Error}
            altText={'location-error'}
            confirmButtonText={BROWSE_MENU_BUTTON}
            cancelButtonText={isPickupOrDineIn ? START_ORDER_BUTTON : null}
            cancelHandler={isPickupOrDineIn ? gotToHome : null}
            confirmHandler={() => {
              gotoMenuPage(closedStore, noStore);
            }}
          />
        }
      />
    )
  );
}

export const displayNotifyMessage = () => {
  return (
    <div className='location-notification col-6'>
      <div className='notify-alert'>
        <ImageComponent srcFile={errorIcon} className='location-alert-icon' />
        <span>{translateWithI18Next(LOCATION_ALERT_MSG)}</span>
      </div>
    </div>
  );
};

/**
 * method to get the lat and long data when user choose's current location
 */
export const getCurrentLocationGlobal = async () => {
  await ChannelManager.BindLocation();
  return ChannelManager.address && ChannelManager.coordinates;
};

export const checkNearBystoresData = allStoresData => {
  return allStoresData.filter(store => {
    return (
      isValidValue(store.id) && isValidValue(store?.location?.latitude) && isValidValue(store?.location?.longitude)
    );
  });
};
